
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/page/[pageNo]",
      function () {
        return require("private-next-pages/blog/page/[pageNo]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/page/[pageNo]"])
      });
    }
  